import { render } from "./AppMobile.footer.vue?vue&type=template&id=98b3f8ea"
import script from "./AppMobile.footer.vue?vue&type=script&lang=js"
export * from "./AppMobile.footer.vue?vue&type=script&lang=js"

import "./AppMobile.footer.vue?vue&type=style&index=0&id=98b3f8ea&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QFooter,QTabs,QRouteTab});
